var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,_vm._b({tag:"component",class:['rph-button', `rph-button--${_vm.type}`, _vm.isCropped && 'rph-button--cropped'],attrs:{"data-test-id":_vm.testId,"disabled":_vm.disabled},on:{"click":_vm.onClickHandler}},'component',_vm.link,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }